import { createModel } from "hox";
import React, { Key, useState } from "react";
import StoreService from "./StoreService";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@src/types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@utils/constants";
import { message } from "antd";
import { IMdStoreDetail, IMdStoreFields } from "./StoreTypes";
import { organService } from "../org/organizationService";
import { TreeDsType } from "@src/components/YhPageHeader/Types";
import { storeService } from "./StoreService";
import { globalPrompt } from "@src/components/YhMessage";
import { trasDsToTreeData } from "../dict/dictModel";
import { useOrganizationModel } from "../org/organizationModel";
import { useEntityModel } from "../entity/entityModel";
import { dictService } from "../dict/DictService";
export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current
    }
}
interface IVRMShopDrawerType {
    visible: boolean,
    mode: "add" | "edit"
}

function StoreModel() {

    const initSearchParam: IMdStoreFields = {};
    const initDataSource: IMdStoreDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IMdStoreFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IMdStoreDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    //列表数据源分页参数

    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [shopTypeDs, setShopTypeDs] = useState<any[]>()

    const [drawerVisible, setDrawerVisible] = useState(false);

    const [resetState, setResetState] = useState(false)

    const [orgDs, setOrgDs] = useState<TreeDsType[]>()
    const [beDs, setBeDs] = useState<any>()
    const { getOrgTreeSelect } = useOrganizationModel(() => []);
    const { beLoadDataAll } = useEntityModel(() => []);
    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
        setResetState(!resetState)
    }
    function listChangeTree(list: any[]) {
        let menuObj: any = {}
        list.forEach(item => {
            item.children = []
            menuObj[item.code as string] = item
        })
        return list.filter(item => {
            if (item.pcode !== null && item.pcode !== "") {
                menuObj[item.pcode as string]?.children.push(item)
                return false
            }
            return true
        })
    }
    /**
         * 加载选择项
         */
    const loadDs = async () => {
        let list: any = await getOrgTreeSelect('org')
        let beds: any = await beLoadDataAll()
        let shopTypes = await dictService.dictItemDs('shop-type');
        setOrgDs(list)
        setBeDs(beds)
        setShopTypeDs(shopTypes)
    }


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdStoreFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
    }

    const loadData = async (page?: ISearchPage, searchValue: IMdStoreFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await StoreService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        records.forEach(item => {
            if (!item.key) {
                item.key = item.id as Key
            }
        })
        setDataSource(records);
    }
    /**
     * 详情
     */
    const initShopDrawer: IVRMShopDrawerType = { visible: false, mode: "add" }
    const [shopDrawer, setShopDrawer] = useState<IVRMShopDrawerType>(initShopDrawer);
    const setIShopDrawer = (str?: "add" | "edit") => setShopDrawer(str ? { visible: true, mode: str } : initShopDrawer);

    //根据id查询
    const getSelectedRowData = () => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        return filters && filters.length > 0 ? { ...filters[0], status: !!!filters[0]?.status, type: !!!filters[0]?.type, details: filters[0]?.details?.map(item => item.bentityCode) ?? [] } : null;
    };

    const insertShop = async (val: any) => {
        let { retData } = await storeService.insert(val);
        if (retData) {
            loadData();
            setIShopDrawer();
            loadData();
            globalPrompt("message", { text: "站点新增成功", type: "success" })
        } else {
            globalPrompt("message", { text: "站点新增失败", type: "error" });
        }
    }

    //表单编辑 Api
    const editShop = async (val: any) => {
        let { retData } = await storeService.update({ ...val, id: selectedRowKeys[0] });
        if (retData) {
            loadData();
            setIShopDrawer();
            loadData();
            globalPrompt("message", { text: "站点修改成功", type: "success" })
        } else {
            globalPrompt("message", { text: "站点修改失败", type: "error" });
        }
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        resetState,
        orgDs,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        getSelectedRowData,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        onSearch,
        onReset,
        loadDs,
        setIShopDrawer,
        insertShop,
        editShop,
        shopDrawer,
        beDs,
        shopTypeDs, setShopTypeDs
    }

}


export const useStoreModel = createModel(StoreModel);